import { lazy, type FC } from 'react';
import { ClientSuspense } from 'dibs-elements/exports/ClientSuspense.tsx';
import { useFragment, graphql } from 'react-relay';
import { PdpMobileSharedPlaceholder } from '../mobileShared/PdpMobileSharedPlaceholder/PdpMobileSharedPlaceholder.tsx';
import { usePdpMwLayoutShiftFixTestVariant } from '../hooks/usePdpMwLayoutShiftFixTestVariant.ts';

import { type PdpSharedUrgencyLazy_buyerUrgencyInfo$key } from './__generated__/PdpSharedUrgencyLazy_buyerUrgencyInfo.graphql.ts';

const PdpSharedUrgency = lazy(
    () => import(/* webpackChunkName: "PdpSharedUrgency" */ './PdpSharedUrgency.tsx')
);

type Props = {
    buyerUrgencyInfo: PdpSharedUrgencyLazy_buyerUrgencyInfo$key;
};

const buyerUrgencyInfoFragment = graphql`
    fragment PdpSharedUrgencyLazy_buyerUrgencyInfo on BuyerUrgencyInfo {
        ...PdpSharedUrgency_buyerUrgencyInfo
    }
`;

export const PdpSharedUrgencyLazy: FC<Props> = ({ buyerUrgencyInfo: buyerUrgencyInfoRef }) => {
    const buyerUrgencyInfo = useFragment(buyerUrgencyInfoFragment, buyerUrgencyInfoRef);
    const isPdpMwLayoutShiftFixVariant = usePdpMwLayoutShiftFixTestVariant();

    return (
        <ClientSuspense
            fallback={
                isPdpMwLayoutShiftFixVariant ? <PdpMobileSharedPlaceholder height={35} /> : null
            }
        >
            <PdpSharedUrgency buyerUrgencyInfo={buyerUrgencyInfo} />
        </ClientSuspense>
    );
};
